import styled from 'styled-components';

const Container = styled.div`
  padding: 15px;
`;

export { Container };
